document.addEventListener('DOMContentLoaded', function () {
  var OPEN_CLASS = 'modal--open';
  var MODAL_SELECTOR = '.modal';
  var CLOSE_SELECTOR = '[data-modal-close]';

  function normalizeId(target) {
    if (!target) return null;
    return target.charAt(0) === '#' ? target : '#' + target;
  }

  function getModal(selector) {
    var modals = Array.prototype.slice.call(document.querySelectorAll(selector));
    if (!modals.length) return null;
    return modals[modals.length - 1];
  }

  function mountModalsOnBody() {
    document.querySelectorAll(MODAL_SELECTOR).forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  function openModal(targetId) {
    var selector = normalizeId(targetId);
    if (!selector) return;

    var modal = getModal(selector);
    if (!modal) return;

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    modal.classList.add(OPEN_CLASS);
    document.documentElement.classList.add('has-open-modal');
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove(OPEN_CLASS);

    if (!document.querySelector(MODAL_SELECTOR + '.' + OPEN_CLASS)) {
      document.documentElement.classList.remove('has-open-modal');
    }
  }

  mountModalsOnBody();
  document.addEventListener('shopify:section:load', mountModalsOnBody);

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-modal-target]');
    if (!btn) return;

    event.preventDefault();
    openModal(btn.getAttribute('data-modal-target'));
  });

  document.addEventListener('click', function (event) {
    var closeTrigger = event.target.closest(CLOSE_SELECTOR);
    if (!closeTrigger) return;

    var modal = closeTrigger.closest(MODAL_SELECTOR);
    if (modal) {
      closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var openModalEl = document.querySelector(MODAL_SELECTOR + '.' + OPEN_CLASS);
    if (openModalEl) {
      closeModal(openModalEl);
    }
  });
});
